jQuery(function($) {
  // ハンバーガーメニュークリック時の動作
  $('.js-global-nav-toggle').click(function() {
    $(".js-global-nav-toggle").toggleClass('open');
    $(".js-global-nav-menu").slideToggle(500);
  });
  
  function mediaQuery() {
    var width = $(window).width();
    if (width > 1099) {
      $(".js-global-nav-toggle").removeClass('open');
      $(".js-global-nav-menu").show();
    } else {
      $(".js-global-nav-toggle").removeClass('open');
      $(".js-global-nav-menu").hide();
    }
  }

  mediaQuery();
  $(window).on("resize", function(){
    mediaQuery();
  });
});